export default "__VITE_ASSET__CPgHIvR0__"